import { PrescriptionAssistantModal } from '@/shared-ui/PrescriptionAssistantModal/PrescriptionAssistantModal';
import { List, ListItem, Typography } from '@montugroup/design-system';

type PrescribeErrorModalProps = {
  open: boolean;
  onConfirm: () => void;
};

const PrescribeErrorModal = ({ open, onConfirm }: PrescribeErrorModalProps) => {
  return (
    <PrescriptionAssistantModal
      open={open}
      title="Prescription Not Created"
      severity="warning"
      body={
        <>
          <Typography paragraph>
            There was an error with your prescription request due to outdated script details.
          </Typography>
          <Typography paragraph marginBottom={0}>
            Next steps:
          </Typography>

          <List sx={{ listStyleType: 'disc', pl: 8, pt: 0 }}>
            <ListItem sx={{ display: 'list-item', padding: '0px' }}>
              Review the patient&#8217;s prescription history
            </ListItem>
            <ListItem sx={{ display: 'list-item', padding: '0px' }}>Update the prescription if needed.</ListItem>
          </List>
        </>
      }
      confirmLabel="View Prescriptions"
      onConfirm={onConfirm}
    />
  );
};

export { PrescribeErrorModal };
